import { render, staticRenderFns } from "./SetAppointment.vue?vue&type=template&id=003af753&"
import script from "./SetAppointment.vue?vue&type=script&lang=js&"
export * from "./SetAppointment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports